import { Injectable } from '@angular/core';
import { AppCommunicationService } from './app-communication.service';
import { Router } from '@angular/router';
import { FaqModel } from '../models/faq.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { getCreateFaqUrl, getDeleteFaqUrl, getFaqBySystemUrl, getUpdateFaqUrl } from '../app.urls';
import { AuthenticationService } from '../../core-frontend-common/auth/authentication.service';

@Injectable()
export class EtdService {

  constructor(
    private _http: HttpClient,
    private router: Router,
    private _authenticationService: AuthenticationService,
  ) {
  }

  getAllFaqs(): Observable<FaqModel[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this._authenticationService.checkUser()) {
      return this._http
        .get(getFaqBySystemUrl('etd'), httpOptions)
        .pipe(map((res: any) => res.items));
    }
  }

  createFaq(faq: FaqModel): Observable<FaqModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this._authenticationService.checkUser()) {
      return this._http
        .post(getCreateFaqUrl(), faq, httpOptions)
        .pipe(map(res => res as FaqModel));
    }
  }

  updateFaq(faq: FaqModel): Observable<FaqModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this._authenticationService.checkUser()) {
      return this._http
        .put(getUpdateFaqUrl(faq.id), faq, httpOptions)
        .pipe(map(res => res as FaqModel));
    }
  }

  deleteFaq(id: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this._authenticationService.checkUser()) {
      return this._http
        .delete(getDeleteFaqUrl(id), httpOptions);
    }
  }
}
